export default "__VITE_ASSET__3d72a8c9__"